<template>
  <div>
    <template v-if="project">
      <div class="p-ml-3" >
        <h1 class="p-mb-0">{{ isAdmin ? `${company.companyname} - `: '' }}{{ project.projectname  }}</h1>
        <p class="subHeader">Legg til / fjern tilganger</p>
      </div>
      <DataTable 
        :value="owner" 
        dataKey="uid"
        sortField="name"
        :sortOrder="1"
      >
        <Column headerStyle="width: 3rem">
          <template #body>
            <div/>
          </template>
        </Column>
        <Column field="name" header="Prosjekteier"></Column>
        <Column field="Email" header="Epost">
          <template #body="slotProps">
            <p>
              <a :href="`mailto:${slotProps.data.Email}`">{{ slotProps.data.Email }}</a>
            </p> 
          </template>
        </Column>
        <Column field="phone" header="Telefon"></Column>
      </DataTable>
      
      <DataTable 
        :value="employees" 
        :selection.sync="selected" 
        dataKey="uid"
        sortField="name"
        :sortOrder="1"
      >
        <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
        <Column field="name" header="Tilgang"></Column>
        <Column field="Email" header="Epost">
          <template #body="slotProps">
            <p>
              <a :href="`mailto:${slotProps.data.Email}`">{{ slotProps.data.Email }}</a>
            </p> 
          </template>
        </Column>
        <Column field="phone" header="Telefon"></Column>
        <template #footer>
          <div class="p-d-flex p-jc-end">
            <Button label="lukk" @click="$router.go(-1)" icon="pi pitimes" class="p-button-text p-mr-2"/>
            <Button label="Largre" autofocus @click="save()"/>
          </div>
        </template>
      </DataTable>
    </template>
  </div>
</template>



<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

export default {
name: 'projectAddUser',
components: {
  DataTable,
  Column,
},

data(){
  return{
    selected: [], 
    changeUsersDialog: false
  }
},

created(){
  //this.selected = this.preSelected
  this.$store.dispatch('projects/inspect', {id: this.$route.params.id, type: 'project'}).then(() => {
    this.$store.dispatch('employees/inspect', {id: this.company.organizationnumber,  type: 'company'}).then(() => {
      this.project.useraccess.forEach(id => {
        this.$db.collection('users').doc(id).get().then((employee) => {
          if(!employee.empty)
          if(this.isOwner(employee)){
            this.owner = {
              id: employee.id, 
              ...employee.data()
            }
          }
          this.selected.push({
            id: employee.id, 
            ...employee.data()
          })
        })
      })
    })
  })
},

methods: {
  isOwner(employee){
    return this.project.owner.id == employee.id
  },
  close(){
    this.$emit('close')
  },

  save(){
    const index = this.selected.findIndex(item => item.id == this.project.owner.id)
    if(index == -1){
      this.selected.push(this.owner)
    }
    this.$store.dispatch('projects/update', {id: this.$route.params.id , data: {useraccess: this.selected.map(item => item = item.id)}}).then(() => {
      this.$toast.add({
        severity:'success',
        summary: 'Tilganger er oppdatert',
        detail: `${this.selected.length} persone${this.selected.length > 1 ? 'r' : ''} har nå tilgang`,
        life: 5000,
      })

      this.$router.push({name: 'project', params: {id: this.project.id}})
    })
  }

},

computed: {
  employees(){
    return this.$store.getters["employees/inspect"].filter(item => !this.isOwner(item))
  },
  owner:{
    get(){
      return this.$store.getters["employees/inspect"].filter(item => this.isOwner(item))
    },
    set(){}
    
  },
  company(){
    return this.$store.getters['companies/current']
  },
  project(){
    return this.$store.getters['projects/inspect']
  },
  isAdmin(){
    return this.$store.getters["user/isAdmin"]
  }
}

}

</script>